import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AppConfiguration } from '../config/app-configuration';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private pendingHTTPRequests$ = new Subject<void>();

    constructor(private router: Router, private appConfig: AppConfiguration) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (localStorage.getItem('token') != null) {
            if (req.url == this.appConfig.urlInformation) {
                const clonedReq = req.clone({
                    headers: req.headers.set("Authorization", "Basic " + btoa(this.appConfig.polarixapiuser + ":" + this.appConfig.polarixapipass),)
                });
                return next.handle(clonedReq).pipe(
                    tap(
                        succ => { },
                        err => {
                            if (err.status === 401) {
                                localStorage.removeItem('token');
                                this.router.navigateByUrl('/login');
                            }
                        }
                    )
                );

            } else {
                let clonedReq = req.clone({
                    headers: req.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'))
                });

                const customerid = localStorage.getItem('customerid');
                if (customerid && req.method === 'POST' && req.url.includes('/FlexIntegration') &&
                    clonedReq.body && typeof clonedReq.body === 'object') {
                    clonedReq = clonedReq.clone({ body: { ...clonedReq.body, customerid } });
                }

                return next.handle(clonedReq).pipe(
                    takeUntil(this.pendingHTTPRequests$.asObservable()),
                    tap(
                        succ => { },
                        err => {
                            if (err.status === 401) {
                                localStorage.removeItem('token');
                                this.router.navigateByUrl('/login');
                            }
                        }
                    )
                );
            }
        } else {
            return next.handle(req.clone());
        }
    }
}
